import styled, { css } from 'styled-components'
import { TypographyComponent } from '../../components/Typography'
import theme from '../../styles/theme'

import CancelIcon from '@mui/icons-material/Cancel'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import VerifiedIcon from '@mui/icons-material/Verified'

import { ArrowRight } from '@mui/icons-material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import TwitterIcon from '@mui/icons-material/Twitter'
import { Button } from 'src/components/Button'
import { ButtonLarge } from 'src/components/ButtonLarge'
import { TFileStatuses } from 'src/services/backend'

export const ContainerFlex = styled('div')(
  () => css`
    display: flex;
    width: 100%;
    padding: ${theme.layout.padding.base * 10}rem;
    gap: ${theme.layout.gap.base * 4}rem;
    flex-direction: column;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
      padding: ${theme.layout.padding.small};
    }
  `
)

export const Content = styled('div')(
  () => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 100%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
      justify-content: flex-start;
    }
  `
)

export const ContainerContent = styled('div')(
  () => css`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    width: 100%;
    gap: ${theme.layout.gap.base * 4}rem;
  `
)

export const ContainerDescription = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1.8rem;
  `
)

export const Title = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h10};
  `
)

export const SubTitle = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h4};
    color: ${theme.colors.base.gray300};
    text-transform: uppercase;
  `
)

export const Typography = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h7};
      font-weight: 700;
      color: ${theme.colors.primary.main70};
      gap: 0.5rem;
      p {
        font-weight: 700;
        color: ${theme.colors.primary.main};
      }
    }
  `
)

export const Text = styled(TypographyComponent)(
  () => css`
    && {
      margin-bottom: ${theme.layout.margin.small};
      width: 75%;
      span {
        color: ${theme.colors.primary.main20};
      }
      font-size: ${theme.typograph.fontsize.h4};
    }
  `
)

export const ContainerMidias = styled('div')(
  () => css`
    && {
      display: flex;
      align-items: center;
      gap: ${theme.layout.gap.small};
    }
  `
)

export const FaceBookIcon = styled(FacebookOutlinedIcon)(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.big};
      color: ${theme.colors.primary.main};
    }
  `
)

export const InstaIcon = styled(InstagramIcon)(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.big};
      color: ${theme.colors.primary.main};
    }
  `
)

export const TwitteIcon = styled(TwitterIcon)(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.big};
      color: ${theme.colors.primary.main};
    }
  `
)

export const Check = styled(CheckIcon)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const Close = styled(CloseIcon)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const LinkdinIcon = styled(LinkedInIcon)(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.big};
      color: ${theme.colors.primary.main};
    }
  `
)

export const ContainerVerified = styled('div')(
  ({ theme }) => css`
    && {
      display: flex;
      margin: ${theme.layout.margin.small} 0;
      gap: ${theme.layout.gap.small};
    }
  `
)

export const HourglassEmpty = styled(HourglassEmptyIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const Verified = styled(VerifiedIcon)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.primary.main};
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const CancelWarning = styled(CancelIcon)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.warning.main};
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const CancelError = styled(CancelIcon)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.error.main};
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const SubscribeIcon = styled(ArrowRight)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.primary.main};
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const TextSuccess = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.primary.main};
      font-weight: 700;
      text-transform: uppercase;
    }
  `
)

export const TextWarning = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.warning.main};
      font-weight: 700;
      text-transform: uppercase;
    }
  `
)

export const TextError = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.error.main};
      font-weight: 700;
      text-transform: uppercase;
    }
  `
)

export const ContainerUpload = styled('div')(
  () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  `
)

export const UploadButton = styled(Button)(
  ({ theme }) => css`
    && {
      display: flex;
      padding: 0;
      align-items: center;
      justify-content: start;
      gap: ${theme.layout.gap.medium};
      border: solid 1px ${theme.colors.primary.main70} !important;

      @media (max-width: ${theme.screen.small}) {
        width: 100%;
      }

      span {
        font-size: ${theme.typograph.fontsize.h4};
        text-transform: uppercase;

        @media (max-width: ${theme.screen.small}) {
          width: 100%;
        }
      }
    }
  `
)

export const Link = styled('div')(
  ({ theme }) => css`
    display: flex;

    span {
      font-size: ${theme.typograph.fontsize.h4};
      text-transform: uppercase;
      margin-right: ${theme.layout.margin.medium};
    }
  `
)

const handleColorType = (status?: TFileStatuses | 'Enviar') => {
  switch (status) {
    case 'Aprovado':
      return 'green'
    case 'Reprovado':
      return 'red'
    case 'Em analise':
      return theme.colors.primary.main
    default:
      'Enviar'
      return 'orange'
  }
}

interface IStatusProps {
  status?: TFileStatuses | 'Enviar'
}

export const Status = styled('div')<IStatusProps>(
  ({ status }) => css`
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.4rem;
    color: ${handleColorType(status)};
  `
)

export const RenderDetail = styled('div')(
  ({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.screen.small}) {
      width: 100%;
    }
  `
)

export const ErrorFile = styled('p')(
  () => css`
    color: red;
    font-size: 1.6rem;
  `
)

export const SubscribeContainer = styled.div(
  ({ theme }) =>
    css`
      align-self: auto;
      position: absolute;
      right: 0px;
      margin-right: 98px;
      @media (max-width: ${theme.screen.large}) {
        margin-right: 28px;
      }
      margin-top: 1rem;
      font-weight: 700;
      color: ${theme.colors.primary.main};
      font-size: ${theme.typograph.fontsize.h3};
      display: flex;
      align-items: end;
      min-width: fit-content;
      cursor: pointer;
    `
)

export const ModalBox = styled.div(
  ({ theme }) => css`
    padding: ${theme.layout.padding.medium};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    background: ${theme.colors.base.white};
    width: 100%;
    gap: ${theme.layout.gap.small};

    @media (max-width: ${theme.screen.small}) {
      width: 90%;
    }
  `
)

export const ModalTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      font-weight: 700;
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h6};
      }
    }
  `
)

export const ModalDescription = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      text-align: start;
      width: 100%;
      font-weight: 700;
      margin-top: ${theme.layout.margin.base * 6}rem;
    }
  `
)

export const ModalBoxButtons = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    right: 0;
    display: flex;
    gap: ${theme.layout.gap.medium};
    justify-content: flex-end;
    width: 100%;
    padding: ${theme.layout.padding.medium} 0;
    background-color: ${theme.colors.base.white};
    z-index: 1;

    @media (max-width: ${theme.screen.small}) {
      justify-content: space-between;
    }
  `
)

export const WarnBox = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.base.lightGray};
    border-radius: ${theme.layout.borderRadius.medium};
    padding: ${theme.layout.padding.medium};
    border-right: 4px solid ${theme.colors.primary.main70};
    border-bottom: 4px solid ${theme.colors.primary.main70};
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.gap.small};
  `
)

export const DownloadButton = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.layout.borderRadius.medium};
    background-color: ${theme.colors.base.lightGray};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.layout.gap.medium};
    cursor: pointer;
    width: 50%;
    padding: ${theme.layout.padding.small};

    @media (max-width: ${theme.screen.small}) {
      width: 100%;
    }

    span {
      font-size: ${theme.typograph.fontsize.h4};
      text-transform: uppercase;
    }
  `
)

export const ButtonIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    background: ${theme.colors.primary.main70};
    padding: ${theme.layout.padding.medium};
    height: 100%;

    svg {
      color: #ffffff;
    }
  `
)

export const ButtonLargeComponent = styled(ButtonLarge)(
  () => css`
    && {
      justify-content: start;
      width: fit-content;
    }
  `
)

export const DocumentContainer = styled('div')(
  () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    margin: 1rem 0;

    @media (max-width: ${theme.screen.small}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `
)

export const Warning = styled('div')(
  () => css`
    && {
      display: block;
      height: fit-content;
      min-height: 70rem;

      p {
        font-size: 1.6rem !important;
      }

      h1,
      h2,
      h3,
      h4,
      h5 {
        font-size: 1.8rem !important;
      }
    }
  `
)
